import { createNode } from '@glueapp/graph-types';

export const NullPrimitive = createNode({
    id: 'Null',
    name: 'Null',
    description: 'Just a null value',
    aiDescription: 'Outputs a null value. No inputs. Single output port "Null" of type null.',
    category: 'Object',
    color: '#a17ee2',
    integration: undefined,
    inPorts: {},
    outPorts: {
        Null: {
            kind: 'null',
        },
    },
    execute: function (input) {
        return { output: { Null: null } };
    },
});
